import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { Library } from 'bookraw/shared/models/library.model';

@Injectable()
export class LibrariesService extends ListService<Library> {

  url: string = '/api/admin/libraries';
}
